// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WatchlistEnum } from '../Enums/WatchlistEnum';
export const GROUP = {
    SYMBOL_INFO: 'FUNCTION_WATCHLIST_SYMBOL_INFORMATION',
    QUOTES: 'FUNCTION_WATCHLIST_QUOTES',
    ADDITIONAL: 'FUNCTION_WATCHLIST_ADDITIONAL_INFORMATION'
};
export const WATCHLIST_COLUMN_RULE = new Map([
    [WatchlistEnum.INSTRUMENT_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_SYMBOL', group: GROUP.SYMBOL_INFO }],
    [WatchlistEnum.DESCR_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_DESCRIPTION', group: GROUP.SYMBOL_INFO }],
    [WatchlistEnum.TYPE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_SYMBOL_TYPE', group: GROUP.SYMBOL_INFO }],
    [
        WatchlistEnum.EXCHANGEMARKETDATA_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_MARKET_DATA_EXCHANGE', group: GROUP.SYMBOL_INFO }
    ],
    [
        WatchlistEnum.EXCHANGETRADING_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_TRADING_EXCHANGE', group: GROUP.SYMBOL_INFO }
    ],
    [WatchlistEnum.CONTRACTSIZE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LOT_SIZE', group: GROUP.SYMBOL_INFO }],
    [WatchlistEnum.EXPDATE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_EXPIRATION_DATE', group: GROUP.SYMBOL_INFO }],
    [WatchlistEnum.NOQUOTES_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LAST_UPDATE', group: GROUP.SYMBOL_INFO }],
    [WatchlistEnum.LAST_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LAST', group: GROUP.QUOTES }],
    [WatchlistEnum.LASTSIZE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LAST_SIZE', group: GROUP.QUOTES }],
    [WatchlistEnum.LASTSOURCE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LAST_SOURCE', group: GROUP.QUOTES }],
    [WatchlistEnum.DATE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LAST_DATE', group: GROUP.QUOTES }],
    [WatchlistEnum.TIME_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LAST_TIME', group: GROUP.QUOTES }],
    [WatchlistEnum.BID_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_BID', group: GROUP.QUOTES }],
    [WatchlistEnum.BIDSIZE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_BID_SIZE', group: GROUP.QUOTES }],
    [WatchlistEnum.BIDSOURCE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_BID_SOURCE', group: GROUP.QUOTES }],
    [WatchlistEnum.ASK_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_ASK', group: GROUP.QUOTES }],
    [WatchlistEnum.ASKSIZE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_ASK_SIZE', group: GROUP.QUOTES }],
    [WatchlistEnum.ASKSOURCE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_ASK_SOURCE', group: GROUP.QUOTES }],
    [WatchlistEnum.SPREAD_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_SPREAD', group: GROUP.QUOTES }],
    [WatchlistEnum.SPREADPR_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_SPREAD_PERCENT', group: GROUP.QUOTES }],
    [WatchlistEnum.CHANGE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_CHANGE', group: GROUP.QUOTES }],
    [WatchlistEnum.CHANGEPR_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_CHANGE_PERCENT', group: GROUP.QUOTES }],
    [WatchlistEnum.OPEN_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_OPEN', group: GROUP.QUOTES }],
    [WatchlistEnum.HIGH_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_HIGH', group: GROUP.QUOTES }],
    [WatchlistEnum.LOW_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LOW', group: GROUP.QUOTES }],
    [WatchlistEnum.PREVCLOSE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_PREV_CLOSE', group: GROUP.QUOTES }],
    [WatchlistEnum.OPENINTEREST_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_OI', group: GROUP.QUOTES }],
    [WatchlistEnum.TICKS_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_TICKS', group: GROUP.QUOTES }],
    [WatchlistEnum.VOLUME_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_VOLUME', group: GROUP.QUOTES }],
    [WatchlistEnum.MAIN_VOLUME_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_VOLUME', group: GROUP.QUOTES }],
    [WatchlistEnum.VOLUMEPREMARKET_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_VOLUME', group: GROUP.QUOTES }],
    [WatchlistEnum.VOLUMEPOSTMARKET_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_VOLUME', group: GROUP.QUOTES }],
    [
        WatchlistEnum.INDICATIVEAUCTIONPRICE_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_IND_AUTCION_PRICE', group: GROUP.ADDITIONAL }
    ],
    [WatchlistEnum.MATCHVOLUME_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_MATCH_VOLUME', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.CURRENTSESSION_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_CURRENT_SESSION', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.TRADINGSTATUS_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_SYMBOL_STATUS', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.SETTLEMENTPRICE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_SETTLEMENT_PRICE', group: GROUP.ADDITIONAL }],
    [
        WatchlistEnum.PREVSETTLEMENTPRICE_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_PREV_SETTLEMENT_PRICE', group: GROUP.ADDITIONAL }
    ],
    [WatchlistEnum.COMMENT_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_COMMENT', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.REFERENCEPRICE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_REFERENCE_PRICE', group: GROUP.ADDITIONAL }],
    [
        WatchlistEnum.CURRENTFUNDINGRATE_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_CURRENT_FUNDING_RATE', group: GROUP.ADDITIONAL }
    ],
    [
        WatchlistEnum.NEXTFUNDINGSETTLEMENT_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_NEXT_FUNDING_SETTLEMENT', group: GROUP.ADDITIONAL }
    ],
    [WatchlistEnum.LPP_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LPP', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.SERIES_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_SERIES', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.SYMBOL_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_EXTERNAL_SYMBOL', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.MARKETTYPE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_MARKET_TYPE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.INSTRUMENTTYPE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_INSTRUMENT_TYPE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.DPR_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_DPR', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.CODE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_CODE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.AUCTIONSTATUS_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_ACCOUNT_STATUS', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.AUCTIONNUMBER_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_AUCTION_NUMBER', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.AUCTIONENDTIME_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_AUCTION_END_TIME', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.TOTALSELLQUANTITY_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_TSQ', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.TOTALBUYQUANTITY_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_TBQ', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.LASTTRADEDTIME_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LTT', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.INITIATORTYPE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_INITIATOR_TYPE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.INITIATORQUANTITY_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_INITIATOR_SIZE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.INITIATORPRICE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_INITIATOR_PRICE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.LOWOPENINTEREST_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_DAY_LOW_OI', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.HIGHOPENINTEREST_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_DAY_HIGH_OI', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.AVGTRADEDPRICE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_AVG_PRICE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.FIFTYTWOWEEKLOWPRICE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_52WL', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.FIFTYTWOWEEKHIGHPRICE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_52WH', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.NSEVALUE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_VALUE', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.TRADEDVALUE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_TRADED_VALUE', group: GROUP.ADDITIONAL }],
    [
        WatchlistEnum.OFFEXCHANGEVOLUME_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_OFF_EXCHANGE_VOLUME', group: GROUP.ADDITIONAL }
    ],
    [
        WatchlistEnum.OFFEXCHANGEVALUE_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_OFF_EXCHNAGE_VALUE', group: GROUP.ADDITIONAL }
    ],
    [
        WatchlistEnum.NORMALMARKETSIZE_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_NORMAL_MARKET_SIZE', group: GROUP.ADDITIONAL }
    ],
    [WatchlistEnum.LIMITHIGH_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_TRADED_HIGH_LIMIT', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.LIMITLOW_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_LOW_LIMIT', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.CBAUCTIONSTART_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_CB_AUCTION_START', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.REMAININGQTY_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_REMAINING_QTY', group: GROUP.ADDITIONAL }],
    [
        WatchlistEnum.REMAININGQTYSIDE_COL_INDEX,
        { rule: 'FUNCTION_WATCHLIST_REMAINING_QTY_SIDE', group: GROUP.ADDITIONAL }
    ],
    [WatchlistEnum.ORDER_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_ORDER', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.TRADE_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_MARKET_ORDER', group: GROUP.ADDITIONAL }],
    [WatchlistEnum.ITCHARTADVANCED_COL_INDEX, { rule: 'FUNCTION_WATCHLIST_IT_ADVANCED_CHART', group: GROUP.ADDITIONAL }]
]);
